import OrtCheckbox from "./OrtCheckbox";
import OrtDropdown from "./OrtDropdown";

export default function OrtForm({filters, setFilters}) {
    return <div className="ort-form">
        <div className="ort-form__filters ort-form__filters--types">
            <OrtDropdown label="Ansicht filtern" slug="types">
                {window.baukulturMap.types.map((item, index) => <OrtCheckbox item={item}
                                                                             group='types'
                                                                             filters={filters}
                                                                             setFilters={setFilters}
                                                                             key={index}/>)}
            </OrtDropdown>
        </div>
        <div className="ort-form__filters ort-form__filters--years">
            <OrtDropdown label="Kategorien" slug="years">
                {window.baukulturMap.years.map((item, index) => <OrtCheckbox item={item}
                                                                             group='years'
                                                                             filters={filters}
                                                                             setFilters={setFilters}
                                                                             key={index}/>)}
            </OrtDropdown>
        </div>
        <div className="ort-form__filters ort-form__filters--properties">
            <OrtDropdown label="Suche eingrenzen" slug="properties">
                <strong className="ort-form__dropdown-section-label">Nutzungen</strong>
                {window.baukulturMap.usages.map((item, index) => <OrtCheckbox item={item}
                                                                              group='usages'
                                                                              filters={filters}
                                                                              setFilters={setFilters}
                                                                              key={index}/>)}
                <strong className="ort-form__dropdown-section-label">Weitere Filter</strong>
                {window.baukulturMap.furtherFilters.map((item, index) => <OrtCheckbox item={item}
                                                                                      group='furtherFilters'
                                                                                      filters={filters}
                                                                                      setFilters={setFilters}
                                                                                      key={index}/>)}
            </OrtDropdown>
        </div>
    </div>
}
